import React from 'react';
import ImageHoverContainer from '../../Componant/Gallery/ImageHover';

const ImageHover = () => {
  return (
    <div className='page-body'>
      <ImageHoverContainer />
    </div>
  );
};

export default ImageHover;
